import React, { useState, useEffect } from 'react';
import style from './index.module.css';
import ClientCard from '../../components/ClientCard';
import MyFooter from '../../components/MyFooter';
import { getFirestore } from 'firebase/firestore';
import { firebaseApp } from '../../utils/firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import CircularProgress from '@mui/material/CircularProgress';
import { clientList } from '../../assets/constants';

const Clients = () => {
	const theme = useTheme();
	const [customersData, setCustomersData] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchClients = async () => {
			try {
				const db = getFirestore(firebaseApp);
				// Trying 'customers' first as per previous code
				const visitedRef = collection(db, 'customers');
				const response = await getDocs(visitedRef);
				
				if (response.empty) {
					console.log('No customers found in Firebase, using local data');
					setCustomersData(clientList);
				} else {
					const customers = response.docs.map(doc => doc.data());
					setCustomersData(customers);
				}
			} catch (error) {
				console.error('Error fetching customer data:', error);
				// Fallback to local data on error
				setCustomersData(clientList);
			} finally {
				setLoading(false);
			}
		};

		fetchClients();
	}, []);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			<div className={style.container}>
				<div className={style.header}>
					<p style={{ color: theme.palette.primary.main }}>TESTIMONIALS</p>
					<h1>Our Valuable Clients</h1>
				</div>

				{loading ? (
					<div className={style.loaderContainer}>
						<CircularProgress color="primary" />
					</div>
				) : (
					<motion.div 
						variants={{
							animate: {
								transition: {
									staggerChildren: 0.1
								}
							}
						}}
						initial="initial"
						animate="animate"
						className={style.clientListStyle}
					>
						{customersData.map((item, index) => {
							return (
								<motion.div 
									key={index}
									variants={{
										initial: { opacity: 0, y: 20 },
										animate: { opacity: 1, y: 0 }
									}}
								>
									<ClientCard
										name={item.name}
										sign={item.sign}
										from={item.from}
									/>
								</motion.div>
							);
						})}
					</motion.div>
				)}
			</div>

			{/* Footer Section */}
			<MyFooter />
		</motion.div>
	);
};

export default Clients;
